module.exports = __webpack_public_path__ + "dist/assets/img/E.c5178869.svg";